import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useProcessPortalRoute = () => {
  const location = useLocation();

  const routePrefix = useMemo(() => {
    return location.pathname.startsWith('/admissao')
      ? '/admissao'
      : '/process-portal';
  }, [location.pathname]);

  return {
    routePrefix,
    signinRoute: `${routePrefix}/signin`,
    listRoute: routePrefix,
    newRoute: `${routePrefix}/new`,
    editRoute: `${routePrefix}/edit`,
  };
};
